<template>
  <div class="cup" :class="{ _active: active }" @mouseover="active = true" @mouseleave="active = false">
    <div class="cup__close" @click="active = !active">
      <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="10" y="18.4375" width="11.9324" height="1.44788" rx="0.723939" transform="rotate(-45 10 18.4375)" fill="#F1C27A"/>
        <rect x="18.4375" y="19.4609" width="11.9324" height="1.44788" rx="0.723939" transform="rotate(-135 18.4375 19.4609)" fill="#F1C27A"/>
        <rect x="1" y="1" width="27" height="27" rx="13.5" stroke="#F1C27A" stroke-width="2"/>
      </svg>
    </div>
    <div class="cup__img-wrapper" @click="active = !active">
      <img src="../assets/images/steam.png" class="cup__steam" alt="">
      <img src="../assets/images/steam.png" class="cup__steam" alt="">
      <img src="../assets/images/cup.png" alt="" class="cup__img">
    </div>
    <div class="cup__text">как получить?</div>
    <div class="cup-popup">
      <div class="cup-popup__title">Приглашаем Вас <br>попробовать кофе</div>
      <img src="../assets/images/logo-black.svg" class="cup-popup__logo only-desktop" alt="">
      <div class="cup-popup__logo-text only-mobile">Poetti</div>
      <div class="cup-popup__text">с 15.12.22 по 15.02.23</div>
      <ul class="cup-popup__list">
        <li 
          v-for="(item, i) in items"
          :key="i"
          class="cup-popup__item"
        >
          <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.42 4.61028C18.5154 5.39262 17.7916 6.07456 16.9991 6.65789C14.2155 8.7054 12.9739 11.512 12.9383 14.9119C12.901 18.4257 11.5696 21.1724 8.47304 22.9794C7.72906 23.4132 7.17773 23.3797 6.48677 22.8739C4.28006 21.2614 3.69263 18.9802 4.08438 16.5244C4.92204 11.2771 7.67316 7.21596 12.264 4.53963C14.4556 3.26034 16.8195 2.99234 19.42 4.61028Z" fill="#F1C27A"/>
            <path d="M9.36872 24.357C10.2253 23.6845 10.856 23.1707 11.5071 22.6861C13.5414 21.174 14.7596 19.146 14.5688 16.6065C14.2029 11.8423 16.5566 8.66558 20.1115 6.01198C20.9586 5.37854 21.4361 5.53529 22.049 6.21965C23.393 7.72429 23.9237 9.51427 23.7712 11.4341C23.3172 17.293 20.3673 21.5148 15.1142 24.0608C14.235 24.5067 13.2698 24.7633 12.2805 24.8143C11.2911 24.8653 10.2994 24.7096 9.36872 24.357Z" fill="#F1C27A"/>
          </svg>
          <div class="cup-popup__item-title">{{ item.title }}</div>
          <div class="cup-popup__item-text">{{ item.text | typograf }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    active: false,
    items: [
      {
        title: "Приходите",
        text: "в ТЦ Европейский, по адресу г.Москва, площадь Киевского Вокзала, 2 (1й этаж Атриум Москва)"
      },
      {
        title: "Сфотографируйтесь",
        text: "на фото-зоне Poetti"
      },
      {
        title: "Примите участие",
        text: "в фотоконкурсе «Мастер дела»"
      },
      {
        title: "Получите",
        text: "у промоутера кофейную пару Poetti"
      }
    ]
  }),
}
</script>

<style lang="scss" scoped>
.cup {
  position: fixed;
  bottom: 3%;
  right: 2%;
  flex-direction: column;
  align-items: flex-end;
  transform: translateY(76%);
  transition: .4s;
  z-index: 1000;
  &._active {
    transform: translateY(0%);
  }
  &__text {
    color: #FFF;
    text-align: center;
    font-size: rem(16px);
    font-family: "OpiumNew-Bold";
    text-transform: uppercase;
    letter-spacing: .1em;
  }
  &__img {
    position: relative;
    width: 100%;
    cursor: pointer;
    z-index: 1;
    &-wrapper {
      position: relative;
      width: rem(130px);
      margin: auto;
      margin-bottom: rem(5px);
      z-index: 1;
      &::before {
        content: '';
        position: absolute;
        top: 30%;
        left: 50%;
        width: rem(290px);
        height: rem(290px);
        display: block;
        transform: translate(-50%,-50%);
        background: url('../assets/images/shadow-2.png') no-repeat center;
        background-size: contain;
        z-index: -1;
      }
    }
  }
  &__steam {
    position: absolute;
    top: 0%;
    left: 0%;
    width: 100%;
    animation: steam 5s ease-out infinite;
    z-index: 0;
    &:nth-of-type(2) {
      animation-delay: 2s;
    }
  }
  &__close {
    position: absolute;
    top: rem(5px);
    right: 0;
    width: rem(29px);
    height: rem(29px);
    opacity: 0;
    transition: .4s;
    cursor: pointer;
    svg {
      width: 100%;
      height: 100%;
      display: block;
    }
    ._active & {
      opacity: 1;
    }
  }
  &-popup {
    position: relative;
    margin-top: rem(-50px);
    width: rem(210px);
    max-width: 100vw;
    padding: rem(30px) rem(10px) rem(20px);
    transform: translateY(10%);
    background: #FFF;
    color: #000;
    border: rem(3px) solid $yellow;
    text-align: center;
    opacity: 0;
    pointer-events: none;
    transition: .4s;
    ._active & {
      opacity: 1;
      transform: translateY(0%);
      transition-delay: .4s;
      pointer-events: all;
    }
    &__title {
      margin-bottom: rem(3px);
      font-family: "OpiumNew-Bold";
      text-transform: uppercase;
      font-size: rem(13px);
      line-height: rem(16px);
    }
    &__logo {
      width: rem(100px);
      margin: 0 auto rem(8px);
      &-text {
        justify-content: center;
        margin: auto;
        font-family: "OpiumNew-Bold";
        font-size: rem(20px);
        text-align: center;
      }
    }
    &__text {
      font-family: "OpiumNew-Bold";
      text-transform: uppercase;
      font-size: rem(10px);
    }
    &__item {
      display: flex;
      flex-direction: column;
      align-items: center;
      svg {
        width: rem(20px);
      }
      &-title {
        font-size: rem(13px);
        text-transform: uppercase;
        font-family: "OpiumNew-Bold";
      }
      &-text {
        font-size: rem(10px);
      }
    }
  }
  @media (min-width: $md) {
    align-items: center;
    &__text {
      font-size: rem(20px);
    }
    &__img {
      &-wrapper {
        width: rem(190px);
      }
    }
    &-popup {
      width: rem(350px);
      margin-top: rem(-70px);
      padding: rem(50px) rem(30px) rem(30px);
      &__title {
        margin-bottom: rem(18px);
        font-size: rem(15px);
      }
      &__logo {
        width: rem(132px);
      }
      &__text {
        margin-bottom: rem(10px);
        font-size: rem(13px);
      }
      &__item {
        svg {
          width: rem(25px);
        }
        &-title {
          font-size: rem(16px);
        }
        &-text {
          font-size: rem(13px);
        }
      }
    }
  }
}
@keyframes steam {
  0% {
    opacity: 1;
    transform: translateY(0%);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(-100%);
  }
}
</style>